import { Form, Switch } from "antd";
import React from "react";

const CovidRisk: React.FC = () => {
  return (
    <Form.Item name="hasCovidScore" label="Show Covid Risk?">
      <Switch />
    </Form.Item>
  );
};

export default CovidRisk;
